import { render, staticRenderFns } from "./selection-list.vue?vue&type=template&id=7f960dde&"
import script from "./selection-list.vue?vue&type=script&lang=ts&"
export * from "./selection-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports